import { render } from "./DrawerItem.vue?vue&type=template&id=16e8764e&scoped=true"
import script from "./DrawerItem.vue?vue&type=script&lang=js"
export * from "./DrawerItem.vue?vue&type=script&lang=js"

import "./DrawerItem.vue?vue&type=style&index=0&id=16e8764e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e8764e"]])

export default __exports__